// extracted by mini-css-extract-plugin
export default {"productDescription":"R_-z","featuredDescription":"S_-z","description":"T_-z","more":"U_-z","descriptionSku":"V_-z"};